var map = {
	"./calculator.png": 4223,
	"./cloud-accounting.png": 507,
	"./compliance.png": 9365,
	"./feedback.png": 7095,
	"./financial-advisor.png": 2125,
	"./innovation.png": 6259,
	"./prototype.png": 2460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4449;